/*eslint-disable */
import React, { useState, useEffect } from "react";
import * as yup from "yup";
import {
  Button,
  Modal,
  Form as FormUi,
  Input,
  Checkbox,
  Dropdown,
} from "semantic-ui-react";
import { withFormik, Field as Fieldmik, FieldArray } from "formik";
import { isEmpty } from "lodash";
import { connect } from "react-redux";
import moment from "moment";

import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { translate } from "react-i18next";
import { AgGridReact } from "ag-grid-react";
import ViewDetails from "../common/viewDetails";
import ViewLRDetails from "../common/viewLRDetails";
import OrderDetailsInvoice from "../shipmentComponent/orderDetailsInvoice.jsx";
import ReadAxios from "../axiosComponent/read";

import AddPod from "../vendor-login/modals/podModal.js";
import ViewPod from "../vendor-login/modals/viewPod";
import VendorLrModal from "../vendor-login/modals/vendorLr.js";

const ModalDeliveryDetails = ({
  values,
  touched,
  errors,
  isSubmitting,
  handleSubmit,
  setFieldValue,
  t,
  modalOpen,
  handleClose,
  deliveryDetails,
  orderDetail,
  viewModeData,
  auth,
  movementType
}) => {
  const [modalData, setModalData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [orderData, setOrderData] = useState({});
  const [podModal, setPodModal] = useState(false);
  const [viewPodModal, setViewPodModal] = useState(false);


  const [openLRModal, setOpenLRModal] = useState(false);
  const [dataLRModal, setDataLRModal] = useState({});
  const [vendorId, setVendorId] = useState("");

  const [orderList, setOrderList] = useState([]);
  const [deliveryList, setDeliveryList] = useState([]);
  const [deliveryNo, setDeliveryNo] = useState('z');


  useEffect(() => {
    setModalData(viewModeData);
    setLoading(false);
  }, [viewModeData, orderDetail, deliveryDetails]);

  const handleSubmited = () => { };

  const columnDefsView = [
    {
      headerName: "Delivery No",
      field: "delivery_no",
    },
    {
      headerName: "Booking No",
      field: "booking_number",
    },
    {
      headerName: "Consignor Name",
      field: "consignor_name",
      hide: movementType == 'primary' ? false : true,
    },
    {
      headerName: "Port Terminal Name",
      field: "consignor_name",
      hide: movementType == 'import' ? false : true,
    },
    {
      headerName: "Stuffing Location Name",
      field: "consignor_name",
      hide: movementType == 'export' ? false : true,
    },
    {
      headerName: "Consignor City",
      field: "consignor_city",
      hide: movementType == 'primary' ? false : true,
    },
    {
      headerName: "Port Terminal City",
      field: "consignor_city",
      hide: movementType == 'import' ? false : true,
    },
    {
      headerName: "Stuffing Location City",
      field: "consignor_city",
      hide: movementType == 'export' ? false : true,
    },
    {
      headerName: "Consignee Name",
      field: "consignee_name",
      hide: movementType == 'primary' ? false : true,
    },
    {
      headerName: "Delivery location Name",
      field: "consignee_name",
      hide: movementType == 'import' ? false : true,
    },
    {
      headerName: "Port terminal Name",
      field: "consignee_name",
      hide: movementType == 'export' ? false : true,
    },
    {
      headerName: "Consignee City",
      field: "consignee_city",
      hide: movementType == 'primary' ? false : true,
    },
    {
      headerName: "Delivery location City",
      field: "consignee_city",
      hide: movementType == 'import' ? false : true,
    },
    {
      headerName: "Port terminal City",
      field: "consignee_city",
      hide: movementType == 'export' ? false : true,
    }/* ,
    {
      headerName: "Delivery Date",
      field: "delivery_date",
    } */,
    {
      headerName: "Scheduled Pickup Date",
      field: "pickup_date",
    },
    {
      headerName: "Scheduled Delivery Date",
      field: "delivery_date",
    },
    {
      headerName: "POD Status",
      field: "pod_status",
    },
    {
      headerName: "Lorry Receipt",
      field: "lorry_receipt",
      cellRenderer: "ViewLRDetails",
    },
    {
      headerName: "POD",
      field: "pod",
      cellRenderer: "ViewDetails",
    },
  ];

  let rowValue = []

  modalData && modalData.forEach((object, index) => {
    let temp = {}
    temp = object;
    let pickup_date_contnr, return_date_contnr;
    if (object?.container_pickup_date) {
      let day = moment(object.container_pickup_date, 'YYYY/MM/DD').date();
      let month = 1 + moment(object.container_pickup_date, 'YYYY/MM/DD').month();
      if (month < 10) {
        month = "0" + month
      }
      let year = moment(object.container_pickup_date, 'YYYY/MM/DD').year();
      let timeextract = moment(object.container_pickup_date).format("HH:mm a")

      pickup_date_contnr = day + "-" + month + "-" + year + " | " + timeextract
    }
    if (object?.container_return_date) {
      let day = moment(object.container_return_date, 'YYYY/MM/DD').date();
      let month = 1 + moment(object.container_return_date, 'YYYY/MM/DD').month();
      if (month < 10) {
        month = "0" + month
      }
      let year = moment(object.container_return_date, 'YYYY/MM/DD').year();
      let timeextract = moment(object.container_return_date).format("HH:mm a")

      return_date_contnr = day + "-" + month + "-" + year + " | " + timeextract
    }
    temp.delivery_no = object?.delivery_no || "NA"
    temp.consignor_name = object?.consignor_name || "NA"
    temp.consignee_name = object?.consignee_name || "NA"
    temp.consignee_city = object?.consignee_city || "NA"
    temp.consignor_city = object?.consignor_city || "NA"
    temp.delivery_date = object?.delivery_date || "NA"
    temp.pod_status = object?.pod_status || "NA"
    temp.lorry_receipt = object?.lorry_receipt || "NA"
    temp.pod = object?.pod || "NA"
    temp.booking_number = object?.booking_number || "NA"
    temp.container_pickup_date = object?.container_pickup_date ? pickup_date_contnr : "NA"
    temp.container_return_date = object?.container_return_date ? return_date_contnr : "NA"

    rowValue[index] = temp
  })

  const [openViewDetails, setOpenViewDetails] = useState(false);

  const handleViewDetailClose = (data) => {
    setOpenViewDetails(false);
  };

  const getRowDetails = (data) => {
    console.log("-------------------data")
    console.log(data)
    const element = data.order;
    element.order_no = element.order_reference_no;
    setOrderList(element);
    let deliveryData = [];
    deliveryData.push(data)
    setDeliveryList(deliveryData)
    setDeliveryNo(data.delivery_no)

    if(data.pod_status == 'Not Deliveried'){
      console.log("HA HA HA")
      
      setPodModal(true);
    }
    else{
      console.log("LOL")
      setViewPodModal(true);
    }

  };

  const getRowLRDetails = (data) => {
    setDataLRModal(data);
    setOpenLRModal(true);
  };

  var frameworkcomponent = {
    ViewDetails: ViewDetails,
    ViewLRDetails: ViewLRDetails
  };

  const handleCloseVendorModal = () => {
    setOpenLRModal(false)
    setVendorId("");
  };

  return (
    <div>
      <Modal open={modalOpen} onClose={handleClose} size="fullscreen">
        <Modal.Header className="p-bold-100">
          <div className="d-flex justify-content-between">
          <h2 className="page-title">{"Delivery"}</h2>
            <div className="form-inline">
              <i onClick={handleClose} className="fas fa-times"></i>
            </div>
          </div>
        </Modal.Header>
        <Modal.Content scrolling>
          <div className="ag-theme-material agOver">
            <AgGridReact
              domLayout="autoHeight"
              frameworkComponents={frameworkcomponent}
              columnDefs={columnDefsView}
              loading={loading}
              rowData={rowValue}
              //rowData={modalData}
              getRowDetails={getRowDetails}
              getRowLRDetails={getRowLRDetails}
            ></AgGridReact>

            {deliveryList != null && deliveryList != undefined && deliveryList.length > 0 ?
              <AddPod
                auth={auth}
                deliveryDetails={deliveryList}
                orders={orderList}
                mode="create"
                open={podModal}
                onClose={() => setPodModal(false)}
              />
              :
              null
            }
            {deliveryList != null && deliveryList != undefined && deliveryList.length > 0 ?
              <ViewPod
                auth={auth}
                mode="view"
                delivery_no={deliveryNo}
                deliveryDetails={deliveryList}
                viewPod={viewPodModal}
                orders={orderList}
                viewPodModalClose={() => setViewPodModal(false)} />
              :
              null
            }


            <VendorLrModal
              show={openLRModal}
              handleClose={handleCloseVendorModal}
              dataLRModal={dataLRModal}
              vendorId={vendorId}
              viewModeData={viewModeData}
            />
          </div>
        </Modal.Content>
      </Modal>
    </div>
  );
};

const mapStateToProps = ({ auth }) => {
  return {
    auth,
  };
};

export default connect(mapStateToProps)(
  translate("allot")(ModalDeliveryDetails)
);
